<script>
import { mapState } from 'vuex'
import ForgotPasswordScreenForm from '@/views/ForgotPasswordScreenForm'
import VContentCard from '@/components/VContentCard'
import VAdvertiseImage from '@/components/VAdvertiseImage'

export default {
  name: 'ForgotPasswordScreen',

  components: {
    VContentCard,
    VAdvertiseImage,
    ForgotPasswordScreenForm,
  },

  computed: {
    ...mapState({
      advertise: 'advertise'
    })
  },

  beforeMount() {
    this.$store.dispatch('SEARCH_ADVERTISE')
    this.$store.dispatch('SEARCH_CLIENT_CONFIG')
      .catch(error => this.$log.error(error))
  },
}
</script>

<template>
  <VContentCard>
    <template slot="advertise">
      <VAdvertiseImage
        :visible="advertise.visible"
        :image="advertise.image"
        :link="advertise.link"
      />
    </template>

    <template slot="form">
      <ForgotPasswordScreenForm />
    </template>
  </VContentCard>
</template>
